/**
 * 채점톡 학생 앱 메인 컴포넌트
 * 레트로 게임 스타일의 수학 채점 시스템
 */

import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/LoginPage';
import { HomePage } from './pages/HomePage';
import { SolvePage } from './pages/SolvePage';
import { PageResultPage } from './pages/PageResultPage';
import { ResultSearchPage } from './pages/ResultSearchPage';

function App() {
  const { initAuth } = useAuthStore();

  // 앱 시작 시 인증 상태 복원
  useEffect(() => {
    initAuth();
  }, [initAuth]);

  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected Routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          }
        />

        {/* 문제 풀이 페이지 */}
        <Route
          path="/workbooks/:name/solve"
          element={
            <ProtectedRoute>
              <SolvePage />
            </ProtectedRoute>
          }
        />

        {/* 페이지 결과 화면 */}
        <Route
          path="/workbooks/:workbook/page/:page/result"
          element={
            <ProtectedRoute>
              <PageResultPage />
            </ProtectedRoute>
          }
        />

        {/* 채점 결과 조회 페이지 */}
        <Route
          path="/result-search"
          element={
            <ProtectedRoute>
              <ResultSearchPage />
            </ProtectedRoute>
          }
        />

        {/* Default Redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
